import { render, staticRenderFns } from "./RentalAttachmentsList.vue?vue&type=template&id=4cb59f60&scoped=true"
import script from "./RentalAttachmentsList.vue?vue&type=script&lang=js"
export * from "./RentalAttachmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb59f60",
  null
  
)

export default component.exports